import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-main heading-s hover:text-brand-400 flex size-[40px] cursor-pointer items-center justify-center rounded-full bg-transparent transition-colors duration-150 max-md:text-xs md:size-[50px]'
  },
  variants: {
    selected: {
      true: 'bg-bg-items-white heading-s-bold border-bg-items-black pointer-events-none cursor-default border-1 max-md:text-xs'
    },
    disabled: {
      true: 'text-inactive pointer-events-none cursor-default'
    }
  }
});
